import { render, staticRenderFns } from "./dataAndCases.vue?vue&type=template&id=55ea0022&scoped=true&"
import script from "./dataAndCases.vue?vue&type=script&lang=js&"
export * from "./dataAndCases.vue?vue&type=script&lang=js&"
import style0 from "./dataAndCases.vue?vue&type=style&index=0&id=55ea0022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea0022",
  null
  
)

export default component.exports